import { render, staticRenderFns } from "./WithoutAction.vue?vue&type=template&id=f5d27902"
import script from "./WithoutAction.vue?vue&type=script&lang=js"
export * from "./WithoutAction.vue?vue&type=script&lang=js"
import style0 from "./WithoutAction.vue?vue&type=style&index=0&id=f5d27902&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports